import { render, staticRenderFns } from "./AccordionSection.vue?vue&type=template&id=33baddaa"
import script from "./AccordionSection.vue?vue&type=script&lang=js"
export * from "./AccordionSection.vue?vue&type=script&lang=js"
import style0 from "./AccordionSection.vue?vue&type=style&index=0&id=33baddaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonIcon: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/common/Icon/index.vue').default})
